//
//
//
//
//
//
//

export default {
  props: {
    value: {
      required: false,
      default: null
    }
  }
}
